import {
  AUTHORIZE,
  AUTHORIZE_ERROR,
  CONFIRM_AUTHORIZE,
  CONFIRM_AUTHORIZE_ERROR,
  SIGN_IN,
  SIGN_OUT,
} from '../actions/google.actions'

const initialState = () => ({
  authorizing: false,
  error: null,
  fetching: false,
  isErrorLink: false,
  linkFromGoogle: false,
  user: null,
})

const googleReducer = (state = initialState(), action) => {
  switch (action.type) {
    case AUTHORIZE:
      return {
        ...state,
        authorizing: true,
        fetching: true,
      }

    case AUTHORIZE_ERROR:
      return {
        ...state,
        authorizing: false,
        error: action.error,
        fetching: false,
        isErrorLink: action.isErrorLink,
        linkFromGoogle: false,
      }

    case CONFIRM_AUTHORIZE:
      return {
        ...state,
        authorizing: false,
      }

    case CONFIRM_AUTHORIZE_ERROR:
      return {
        ...state,
        error: null,
      }

    case SIGN_IN:
      return {
        ...state,
        fetching: false,
        linkFromGoogle: true,
      }

    case SIGN_OUT:
      return initialState()

    default:
      return state
  }
}

export default googleReducer
